module.exports = __webpack_public_path__ + "img/blog-3.4d511e30.jpg";